import React from 'react';
import LegalLayout from '../components/LegalLayout';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiMail } = FiIcons;

const Kontakt = () => (
  <LegalLayout title="Kontakt">
    <div className="bg-white/5 border border-white/10 rounded-2xl p-6 flex gap-4 items-start not-prose">
      <div className="w-10 h-10 rounded-full bg-gold/10 border border-gold/30 flex items-center justify-center flex-shrink-0 mt-0.5">
        <SafeIcon icon={FiMail} className="text-gold text-lg" />
      </div>
      <div>
        <p className="font-sans text-gray-300 text-sm leading-relaxed">
          Haben Sie Fragen zum Buch? Schreiben Sie uns – wir antworten in der Regel innerhalb von 2 Werktagen.
        </p>
        <p className="font-sans text-gray-500 text-xs mt-2">
          E-Mail:{' '}
          <a href="mailto:gcvllc@gmail.com" className="text-gold hover:underline">
            gcvllc@gmail.com
          </a>
        </p>
      </div>
    </div>
  </LegalLayout>
);

export default Kontakt;